// .carousel を Flickity で初期化（画像2枚以上のときのみ）
import Flickity from 'flickity';
import imagesLoaded from 'imagesloaded';

document.addEventListener('DOMContentLoaded', () => {
  const carousel = document.querySelector('.carousel');
  if (!carousel) return;

  const opt = {
    autoPlay: true,
    wrapAround: true,
    prevNextButtons: false,
    pauseAutoPlayOnHover: false,
  };
  let flkty = null;
  let resizeTimer = null;

  imagesLoaded(carousel, () => {
    if (carousel.querySelectorAll('img').length <= 1) return;
    flkty = new Flickity(carousel, opt);
    // ユーザー操作後、マウスが領域外に出ると自動再生を再開
    carousel.addEventListener('mouseleave', () => flkty.playPlayer());
    window.addEventListener('resize', () => {
      clearTimeout(resizeTimer);
      resizeTimer = setTimeout(() => {
        flkty.destroy();
        flkty = new Flickity(carousel, opt);
      }, 500);
    });
  });
});
